import React from 'react';
import { useTheme } from '@mui/material';
import { useGetCompanyDetailAndJobGroups } from 'ogp/hooks/queryHooks/companies/use-get-company-detail-and-job-groups';
import { useGetCompanyTheme } from 'ogp/hooks/queryHooks/companies/use-get-company-theme';
import { StyledSidebarLogo } from 'shared/components/sidebar/styled-sidebar-logo';
import type { LogoData, SidebarLogoProps } from './sidebar-logo.types';
import { LOGO_PATH, SMALL_LOGO_PATH } from '../../../../config';

function getLogoData(themeCustomizationEnabled: boolean, customLogo: LogoData): LogoData | null {
  if (!themeCustomizationEnabled) {
    return {
      portalLogoWideUrl: LOGO_PATH,
      portalLogoSquareUrl: SMALL_LOGO_PATH,
    };
  } else if (customLogo) {
    return {
      portalLogoWideUrl: customLogo.portalLogoWideUrl,
      portalLogoSquareUrl: customLogo.portalLogoSquareUrl,
    };
  }
}

const SidebarLogo = ({ to, isSidebarOpen }: SidebarLogoProps) => {
  const companyQuery = useGetCompanyDetailAndJobGroups();
  const themeQuery = useGetCompanyTheme();
  const theme = useTheme();

  const themeCustomizationEnabled = companyQuery.data?.company.themeCustomizationEnabled ?? false;
  const customLogo = theme.companyLogo ?? themeQuery.data?.logo;

  const logoData = getLogoData(themeCustomizationEnabled, customLogo);

  if (!logoData) {
    return null;
  }

  return (
    <StyledSidebarLogo folded={!isSidebarOpen} to={to}>
      <img
        src={isSidebarOpen ? logoData.portalLogoWideUrl : logoData.portalLogoSquareUrl}
        alt="portal logo"
      />
    </StyledSidebarLogo>
  );
};

export { SidebarLogo };
